import React from 'react';
import styled from 'styled-components';

import { FlexProps } from 'src/types';

export const StyledFlexContainer = styled.div<FlexProps>`
    display: flex;
    width: auto;
    align-items: center;
    padding: 0;
    ${({ styles }) => styles};
`;

export const FlexContainer = ({
    children,
    styles,
    onClick,
    className,
}: FlexProps): React.ReactElement => {
    return (
        <StyledFlexContainer className={className} onClick={onClick} styles={styles}>
            {children}
        </StyledFlexContainer>
    );
};
